import React, {useEffect} from "react";
import {useInView} from "react-intersection-observer";
import classNames from "classnames";
import {Product, ProductMediaVariant} from "@/entities/product";
import {ProductMarkers, ProductMedia, ProductPrice, ProductRating} from "@/entities/product";
import {FavoriteButton} from "@/features/toggle-favorite";
import {getUrl} from "@/entities/product";
import {trackProductClick} from "@/features/track-product-click/lib/trackProductClick";
import {Link} from "@/shared/ui/Link";
import {CatalogCardButtons} from "../CatalogCardButtons/CatalogCardButtons";
import styles from "./CatalogCard.module.scss";

type Props = {
    product: Product;
    index?: number;
    className?: string | null;
    registerView?: any;
    variant?: "default" | "withShadow";
    mediaVariant?: ProductMediaVariant;
};

export const CatalogCard = (
    {
        product,
        index,
        className,
        registerView,
        mediaVariant = 'image',
        variant = 'default'
    }: Props
) => {
    const {ref, inView} = useInView({threshold: 1, triggerOnce: true});

    useEffect(() => {
        if (inView && registerView) {
            registerView({...product, index});
        }
    }, [inView]);

    const handleProductClick = () => {
        trackProductClick(product);
    };

    const cardClasses = classNames(styles.card, styles[variant], className);

    return (
        <div ref={ref} className={cardClasses}>
            <div className={styles.inner}>
                <ProductMarkers sticker={product.sticker} className={styles.marker} />
                <FavoriteButton product={product} className={styles.favoriteButton} />
                <ProductMedia product={product} variant={mediaVariant} onClick={handleProductClick} />
                <div className={styles.body}>
                    <div className={styles.priceContainer}>
                        <ProductPrice product={product} />
                        <div className={styles.iconButtons}>
                            <CatalogCardButtons product={product} isIcon />
                        </div>
                    </div>
                    <div className={styles.contentContainer}>
                        <div className={styles.content}>
                            <Link href={getUrl(product)} className={styles.name} onClick={handleProductClick}>
                                {product.h1}
                            </Link>
                            <ProductRating product={product} />
                        </div>
                    </div>
                    {/*<div className={styles.footer}>*/}
                    {/*    <CatalogCardButtons product={product} />*/}
                    {/*</div>*/}
                    <div className={styles.buttons}>
                        <CatalogCardButtons product={product} />
                    </div>
                </div>
            </div>
        </div>
    );
}
